import ProductFeatureAnimation from './productFeatureAnimation/productFeatureAnimation';

window.ProductFeatureAnimation = ProductFeatureAnimation;
